<div class="page-wrapper page-container" [style.background-image]="backgroundImageUrl()">
      <div class="panel panel-info">
          <div class="panel-heading">
              <h1>{{'SB_Login' | translate}}</h1>
          </div>  
          <div class="panel-body">
              <div class="alert alert-success">
                <p class="success"><span>{{'SB_ResetPasswordLoginMessage' | translate}}</span>.</p>
              </div>
              <div>
                <a class="btn btn-link w-100" title="{{'SB_Login' | translate}}" href="{{redirectUrl()}}"><span>{{'SB_Login' | translate}}</span></a>
              </div>
          </div>
      </div>
  <footer class="footer bg-dark text-light py-2 mt-auto">
    <p class="small text-center mb-1">
      <a class="link-light" href="http://www.schoolsbuddy.com" target="_blank">
        &copy; {{ currentYear }} - EveryBuddy Ltd
      </a>
    </p>
    <p class="small text-center mb-0">
      <a class="link-light" href="http://www.schoolsbuddy.com" target="_blank">
        {{'SB_About' | translate}}
      </a>
    </p>
  </footer>
</div>
